import { Checkbox, FormControlLabel, FormGroup, MenuItem } from "@mui/material";
import React, { useState, useContext } from "react";
import { Upload, ArrowsDownUp, Trash } from "tabler-icons-react";
import profile from "../assets/profile.jpg";
import counties from "../assets/counties.json";
import { MenuContext } from "../context/menuContext";
import TextInput from "../utils/TextInput";

function SingleUser() {
	const [county, setCounty] = useState("");
	const { mobileMenu } = useContext(MenuContext);

	const handleChange = (event) => {
		setCounty(event.target.value);
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		console.log("submitted");
	};

	return (
		<div
			className={
				mobileMenu
					? "absolute md:left-64 md:top-0 md:w-[calc(100%-16rem)] py-3 h-screen bg-slate-50 dark:bg-darkbg"
					: "absolute top-[3rem] md:left-[13rem] lg:left-64 md:top-0 md:w-[calc(100%-13rem)] lg:w-[calc(100%-16rem)] py-3 h-screen bg-slate-50 dark:bg-darkbg"
			}>
			<h1 className="mb-3 py-1 text-slate-500 dark:text-darktext px-5 uppercase font-semibold border-b border-b-slate-100 dark:border-darkborder">
				Single User
			</h1>
			<div className="flex flex-col lg:flex-row justify-center lg:justify-between space-y-5 lg:space-x-5 px-5">
				<div className="flex flex-col lg:w-1/4">
					<img
						src={profile}
						alt="profile"
						className="rounded-full object-cover h-28 w-28 mb-2 mx-auto"
					/>
					<div className="bg-white dark:bg-darkbg border border-slate-500 border-dashed rounded-md px-2 pt-2 pb-10">
						<label className="flex flex-col items-center">
							<Upload size={60} className="" />
							<input
								type="file"
								className="block w-full text-sm text-slate-500 file:hidden file-text-sm opacity-0"
								accept=".pdf"
							/>
							<span className="text-xl font-semibold">Upload image</span>
							<p className="text-sm text-slate-500 dark:text-darktext text-center mt-3">
								Click or drag n' drop to upload your profile picture.Only .jpg
								and .png files are allowed.
							</p>
						</label>
					</div>
				</div>
				<div className="flex flex-col grow bg-white border border-slate-200 dark:border-darkborder dark:bg-darkbg rounded-md px-4">
					<h1 className="text-slate-500 dark:text-darktext text-lg font-semibold mt-3">
						User details
					</h1>
					<form
						onSubmit={handleSubmit}
						className=" w-full grid grid-cols-1 lg:grid-cols-2 gap-y-4 lg:gap-x-4 md:gap-y-14 justify-between pb-10 pt-2">
						<TextInput labelText="Username" />
						<TextInput labelText="Email" type="email" />
						<TextInput labelText="First name" />
						<TextInput labelText="Middle name" />
						<TextInput labelText="Last name" />
						<TextInput labelText="Date of birth" />
						<TextInput labelText="Secondary school" />
						<TextInput
							select
							value={county}
							onChange={handleChange}
							labelText="County"
							helperText="Please select your county">
							{counties.map((county) => (
								<MenuItem key={county.name} value={county.name}>
									{county.name}
								</MenuItem>
							))}
						</TextInput>
						<TextInput labelText="Change Password" type="password" />
						<TextInput labelText="Confrim password" type="password" />
						<FormGroup className="text-slate-500 dark:text-darktext">
							<FormControlLabel
								control={<Checkbox />}
								label="Administrator"
								size="small"
							/>
						</FormGroup>
						<div className="lg:row-start-6 lg:col-start-2 flex space-x-4">
							<button className="flex items-center bg-green-400 py-1 px-3 text-slate-200 text-lg font-medium rounded-sm hover:bg-green-500 transition-all duration-150 ease-in-out ml-auto">
								<ArrowsDownUp size={17} className="mr-1" /> Update
							</button>
							<button className="flex items-center bg-red-400 py-1 px-3 text-slate-200 text-lg font-medium rounded-sm hover:bg-red-500 transition-all duration-150 ease-in-out">
								<Trash size={17} className="mr-1" /> Delete
							</button>
						</div>
					</form>
				</div>
			</div>
		</div>
	);
}

export default SingleUser;
